export class TypeDexieError extends Error {}
